export var valuesUserDatabaseType = ["Cosmos"];
/*

*/ 
//# sourceMappingURL=UserDatabaseType.js.map